import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    marginBottom: theme.space[6],
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const UserWrapper = styled.ul(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    background: theme.colors.offWhite,
    padding: theme.space[3],
    marginBottom: 2,

    [breakpoints.md]: {
        padding: theme.space[3],
    },
}));

export const FirstColumn = styled.li(() => ({
    gridColumn: 1,
}));

export const SecondColumn = styled.li(() => ({
    gridColumn: 2,
}));

export const ThirdColumn = styled.li(() => ({
    gridColumn: 3,
    justifySelf: 'end',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    border: 'none',
    background: 'none',
}));

export const StyledText = styled(Text)(({ theme }) => ({
    color: theme.colors.grey70,
}));
